import { isProductSubmission, getProductPrice } from "../utils.js";
function valueEqual(givenValue, expectedValue) {
  if (isProductSubmission(givenValue)) {
    return getProductPrice(givenValue) === expectedValue;
  }
  return givenValue === expectedValue;
}
export {
  valueEqual
};
//# sourceMappingURL=equal.js.map
